import {Injectable, OnDestroy} from '@angular/core';
import {NavigationStart, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';

/** Route der Info-Seite für SSO-Gast-Accounts. */
export const GUEST_USER_INFO_ROUTE = '/guest-user-info';

/**
 * Merkt sich, dass das Backend Aufrufe dieses SSO-Accounts als Gast-Zugriff ablehnt.
 *
 * Der Merker gilt nur für die aktuell angezeigte Seite: ein Seitenaufruf löst viele parallele
 * Requests aus, die alle mit 403 enden — davon darf nur der erste auf die Info-Seite umleiten.
 * Sobald der Nutzer die nächste Aktion auslöst (Navigation auf eine andere Route), wird er
 * zurückgesetzt, damit die Info-Seite auch beim zweiten und jedem weiteren Versuch erscheint.
 */
@Injectable({providedIn: 'root'})
export class GuestAccountService implements OnDestroy {
  private blocked = false;
  // Angular 15 kennt kein takeUntilDestroyed (@angular/core/rxjs-interop ab 16) - deshalb per Hand aufräumen.
  private readonly destroyed$ = new Subject<void>();

  constructor(private router: Router) {
    this.router.events.pipe(
      filter((event): event is NavigationStart => event instanceof NavigationStart),
      filter(event => !event.url.startsWith(GUEST_USER_INFO_ROUTE)),
      takeUntil(this.destroyed$)
    ).subscribe(() => this.blocked = false);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  isBlocked(): boolean {
    return this.blocked;
  }

  markBlocked(): void {
    this.blocked = true;
  }

  reset(): void {
    this.blocked = false;
  }
}
